import { render, staticRenderFns } from "./KnowledgeBaseStep.vue?vue&type=template&id=7e0760ec&"
import script from "./KnowledgeBaseStep.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0760ec')) {
      api.createRecord('7e0760ec', component.options)
    } else {
      api.reload('7e0760ec', component.options)
    }
    module.hot.accept("./KnowledgeBaseStep.vue?vue&type=template&id=7e0760ec&", function () {
      api.rerender('7e0760ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/KnowledgeBaseStep.vue"
export default component.exports